import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=d303180a&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d303180a', component.options)
    } else {
      api.reload('d303180a', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=d303180a&", function () {
      api.rerender('d303180a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/components/Tab.vue"
export default component.exports